<template>
    <v-card>
        <v-overlay :value="dLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular> Espere un momento por favor.
        </v-overlay>
        <v-sheet class="d-flex flex-wrap justify-start">
            <v-sheet class="pa-2" min-width="300" max-width="300" color="light-blue lighten-4">
                <v-card>
                    <v-img src="@/assets/images/fondo1.png" height="180px">
                        <v-btn @click="dModal.dialog = true" rounded x-small dark color="success">
                            <v-icon>search</v-icon> Buscar
                        </v-btn>
                        <v-row v-if="dPriAlumno.docs!=''" justify="space-around">
                            <img :src="'https://proxy.khipu.edu.pe/'+dPriAlumno.docs" height="200">
                        </v-row>
                    </v-img>
                    <div v-show="dPriAlumno.IdAlumno">
                        <v-list two-line>
                            <v-list-item class="px-0" style="height:10px">
                                <v-list-item-icon  class='mr-1'><v-icon @click="$router.push(`/AlumnoItem/${dPriAlumno.IdAlumno}`);" title="Editar">edit</v-icon></v-list-item-icon>
                                <v-list-item-content><v-list-item-subtitle>{{dPriAlumno.Alumno}}</v-list-item-subtitle><v-list-item-subtitle>Apellidos y Nombres</v-list-item-subtitle></v-list-item-content>
                            </v-list-item>
                            <v-list-item class="px-0" style="height:10px">
                                <v-list-item-icon  class='mr-1'><v-icon>credit_card</v-icon></v-list-item-icon>
                                <v-list-item-content><v-list-item-title>{{dPriAlumno.DNI}}</v-list-item-title><v-list-item-subtitle>DNI</v-list-item-subtitle></v-list-item-content>
                            </v-list-item>
                            <v-list-item class="px-0" style="height:10px">
                                <v-list-item-icon  class='mr-1'><v-icon>bookmark</v-icon></v-list-item-icon>
                                <v-list-item-content><v-list-item-title>{{dPriAlumno.priservicio.Iniciales}}</v-list-item-title><v-list-item-subtitle>Carrera</v-list-item-subtitle></v-list-item-content>
                            </v-list-item>
                            <v-list-item class="px-0" style="height:10px">
                                <v-list-item-icon  class='mr-1'><v-icon>qr_code_2</v-icon></v-list-item-icon>
                                <v-list-item-content><v-list-item-title>{{dPriAlumno.Codigo}}</v-list-item-title><v-list-item-subtitle>Codigo</v-list-item-subtitle></v-list-item-content>
                            </v-list-item>
                            <v-list-item class="px-1">
                                <v-list-item-icon  class='mr-1'><v-icon>smartphone</v-icon></v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        <v-text-field @click:append="fuAlumnoSave()" v-model="dPriAlumno.Celular" append-icon="save" :disabled="dIsUpdating" :loading="dIsUpdating" :rules="[v => !!v || 'El campo es requerido', v => (v && v.length <= 9) || 'El campo debe ser menor de 9 caracteres.']" :maxlength="9" autocomplete="off" clearable counter dense style="font-size: 25px !important;"></v-text-field>
                                    </v-list-item-title>
                                <v-list-item-subtitle>Celular</v-list-item-subtitle></v-list-item-content>
                            </v-list-item>
                            <v-list-item class="px-1">
                                <v-btn class="" :class="{ 'success' : !isCameraOpen, 'error' : isCameraOpen}" @click="toggleCamera" block rounded>
                                    <span v-if="!isCameraOpen"><v-icon>videocam</v-icon> TOMAR FOTO</span>
                                    <span v-else><v-icon>videocam_off</v-icon> Cerrar</span>
                                </v-btn>
                            </v-list-item>
                            <v-list-item class="px-1" style="display: inline">

                                <div align="center" justify="center">
                                    <v-btn v-if="isCameraOpen && !isLoading" @click="takePhoto" :loading="isLoading" large icon color="black" title="Tomar Foto"><v-icon size="60">photo_camera</v-icon></v-btn>
                                    <v-btn v-if="isPhotoTaken && isCameraOpen" @click="uploadImage" :loading="isLoading2" large icon color="primary" class="ml-5" title="Guardar"><v-icon size="60">save</v-icon></v-btn>
                                </div>
                            </v-list-item>
                        </v-list>
                    </div>
                </v-card>
                <v-dialog v-model="dModal.dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                    <v-card>
                        <v-toolbar dark color="primary">
                            <v-btn icon dark @click="dModal.dialog=false"><v-icon>close</v-icon></v-btn>
                            <v-toolbar-title>Buscar Alumno</v-toolbar-title>
                        </v-toolbar>
                        <v-card-title style="background-color:#78909C">
                            <v-form ref="refPriAlumno">
                                <v-row fluid>
                                    <v-col cols="9" xm="12" sm="9" md="9" class="pa-1">
                                        <v-text-field @keyup.enter.prevent="fuPriAlumnoSearch" v-model="dDNINombre" label="DNI o Codigo o Apellidos y Nombres" outlined prepend-inner-icon="credit_card" clearable :rules="[v => !!v || 'El campo es requerido']" :maxlength="120" counter autocomplete="off"></v-text-field>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-btn @click.prevent="fuPriAlumnoSearch" :loading="dPriAlumnoTable.loading" color="blue-grey" dark x-large>
                                            <v-icon large>search</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-form>
                            <v-spacer></v-spacer>
                            <v-text-field
                                v-model="dPriAlumnoTable.search"
                                prepend-icon="search"
                                label="Filtrar por ..."
                                clearable
                                single-line
                                dense
                                hide-details
                            ></v-text-field>
                        </v-card-title>
                        <v-data-table
                            v-model="dPriAlumnoTable.selected"
                            :headers="dPriAlumnoTable.headers"
                            :items="dPriAlumnos"
                            :loading="dPriAlumnoTable.loading"
                            :search="dPriAlumnoTable.search"
                            single-select
                            item-key="IdAlumno"
                            class="row-height-50">
                            <template v-slot:no-data><v-alert :value="true" color="warning" icon="warning" outlined border="top">No hay registros para mostrar.</v-alert></template>
                            <template v-slot:no-results><v-alert :value="true" color="warning" icon="warning" outlined border="top">No se encontro ningun registro con su busqueda "{{ dPriAlumnoTable.search }}".</v-alert></template>
                            <template v-slot:[`item.Alumno`]="{ item }">
                                <v-btn @click="fuPriAlumnoSelected(item.IdAlumno)" color="success" text>{{item.Alumno}}</v-btn>
                            </template>
                            <template v-slot:[`item.priservicio.Iniciales`]="{ item }">
                                <h3 style="color:blue">{{item.priservicio.Iniciales}}</h3>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-dialog>
            </v-sheet>
            <v-sheet class="pa-0" align="center" justify="center">
                <v-row v-show="dPriAlumno.IdAlumno" align="center" justify="center">
                <!-- <v-row align="center" justify="center"> -->
                    <v-col class="text-center" cols="12">
                        <div id="app" class="web-camera-container">
                            <div v-show="isCameraOpen && isLoading" class="camera-loading" style="margin-top: 100px">
                                <v-progress-circular
                                    :size="70"
                                    :width="7"
                                    color="primary"
                                    indeterminate
                                ></v-progress-circular>
                            </div>

                            <div v-if="isCameraOpen" v-show="!isLoading" class="camera-box" :class="{ 'flash' : isShotPhoto }">

                            <div class="camera-shutter" :class="{'flash' : isShotPhoto}"></div>                            
                                <video v-show="!isPhotoTaken" ref="camera" :width="1280" :height="720" autoplay></video>
                                <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" :width="1280" :height="720"></canvas>
                            </div>
                            <v-card-text class="pa-0">
                                <div v-if="isCameraOpen" v-show="!isLoading" class="camera-box" :class="{ 'flash' : isShotPhoto }">
                                    <div class="camera-shutter" :class="{'flash' : isShotPhoto}"></div>
                                    <video v-show="!isPhotoTaken" ref="camera" :width="1280" :height="720" autoplay></video>
                                    <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" :width="1280" :height="720" ></canvas>
                                </div>
                            </v-card-text>
                            <div>
                                <img :src="'https://proxy.khipu.edu.pe/'+dImagen" height="400">
                            </div>
                        </div>
                        <v-snackbar v-model="dSnackbar" :color="dSnackbarColor">{{dSnackbarMsg}}
                            <v-btn text @click="dSnackbar = false"> Cerrar </v-btn>
                        </v-snackbar>
                    </v-col>
                </v-row>
            </v-sheet>
        </v-sheet>
    </v-card>
</template>
<script>
import moment from 'moment';
import gql from 'graphql-tag';
import {mapState} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    name: 'AlumnoFoto',
    mounted(){
        this.dVisible = true;
        console.log(this.ssUser.IdPersonal);
        if (typeof this.$route.params.pIdAlumno != "undefined"){
            this.fuPriAlumno(this.$route.params.pIdAlumno);
        }
    },
    data: () => ({
        dDNINombre: '',// 20211C491 50496  57771
        dIsUpdating: false,
        dLoading: false,
        dModal: {
            dialog: false,
            IsUpdating: false,
        },        
        dPriAlumnoTable: {
            headers: [
                {value: 'IdAlumno', text: 'IdAlumno', align: ' d-none'},
                {value: 'Alumno', text: 'Alumno'},
                {value: 'Codigo', text: 'Codigo'},
                {value: 'priservicio.Iniciales', text: 'Carrera', align: 'center', sortable: false},
                {value: 'DNI', text: 'DNI', align: 'center', sortable: false},
            ],
            loading: false,
            search: null,
            selected: []
        },
        dPriAlumnos: [],
        dPriAlumno: {
            IdAlumno: '',
            DNI: '',
            Alumno: '',
            Sexo: '',
            Codigo: '',
            Celular: '',
            docs: '',
            priservicio: {
                IdServicio: '',
                Iniciales: '',
            }
        },
        isCameraOpen: false,
        isPhotoTaken: false,
        isShotPhoto: false,
        isLoading: false,
        isLoading2: false,
        link: '#',
        dAlumnoFoto: {
            dialog: false,
            IsUpdating: false,
        },
        dSnackbar: false,
        dSnackbarMsg: 'Se guardo la imagen.',
        dSnackbarColor: 'success',
        dImagen: '',
        dVisible: true,
        dIdAlumno10: [],
        dIdAlumno30: [],
    }),
    watch: {
        cRuta (val) {
            this.fuPriAlumno(val);
        }
    },
    computed: {
        ...mapState(['ssUser']),
    },
    methods: {
        fuPriAlumnoSearch(){
            this.dPriAlumnoTable.search=null
            if(this.dDNINombre==''){
                this.dSnackbar = true;
            } else {
                if(this.dDNINombre.length==8 && !isNaN(this.dDNINombre))
                    this.fuPrialumnoByDNI(this.dDNINombre)
                else{
                    if(this.dDNINombre.length==9 && !isNaN(this.dDNINombre.substring(0,5)))
                        this.fuPrialumnoByCodigo(this.dDNINombre)
                    else
                        this.fuPrialumnoByAlumno(this.dDNINombre)
                }
            }
        },
        fuPriAlumnoSelected(vIdAlumno){
            this.dPriAlumno.docs = '';
            const result = this.dPriAlumnos.find(({IdAlumno}) => IdAlumno === vIdAlumno);
            this.dPriAlumno.IdAlumno = result.IdAlumno;
            this.dPriAlumno.Alumno = result.Alumno;
            this.dPriAlumno.DNI = result.DNI;      
            this.dPriAlumno.Codigo = result.Codigo;
            this.dPriAlumno.Sexo = result.Sexo;            
            this.dPriAlumno.Celular = result.Celular;
            result.docs ? this.dPriAlumno.docs = JSON.parse(result.docs).FOTO : this.dPriAlumno.docs = '';
            this.dPriAlumno.priservicio.Iniciales = result.priservicio.Iniciales;
            this.dPriAlumno.priservicio.IdServicio = result.priservicio.IdServicio;
            this.dModal.dialog = false;
            // this.fuingingresosalumnoByIDAlumnoByIDEscalaByFInicio(vIdAlumno);
        },
        async fuPriAlumno(pIdAlumno) {
            this.dLoading = true;
            this.dPriAlumno.docs = '';
            try {
                const response = await this.$apollo.query({
                    query: gql`query prialumno($IdAlumno: ID!, $token: String){
                        prialumno(IdAlumno:$IdAlumno, token: $token){
                            IdAlumno
                            Alumno
                            DNI
                            Codigo
                            Celular
                            Sexo
                            docs
                            priservicio{
                                IdServicio
                                Iniciales
                            }
                        }
                    }`,fetchPolicy: 'no-cache',
                    variables: {
                        IdAlumno: pIdAlumno,
                        token: new Date().toISOString()
                    }
                })
                this.dPriAlumno.IdAlumno = response.data.prialumno.IdAlumno;
                this.dPriAlumno.DNI = this.dDNI = response.data.prialumno.DNI;
                this.dPriAlumno.Alumno = this.dAlumno = response.data.prialumno.Alumno;
                this.dPriAlumno.Sexo = response.data.prialumno.Sexo;
                this.dPriAlumno.Codigo = response.data.prialumno.Codigo;
                this.dPriAlumno.Celular = response.data.prialumno.Celular;
                this.dPriAlumno.priservicio.Iniciales = response.data.prialumno.priservicio.Iniciales;
                this.dPriAlumno.priservicio.IdServicio = response.data.prialumno.priservicio.IdServicio;
                response.data.prialumno.docs ? this.dPriAlumno.docs = JSON.parse(response.data.prialumno.docs).FOTO : this.dPriAlumno.docs = '';
                // this.fuingingresosalumnoByIDAlumnoByIDEscalaByFInicio(pIdAlumno);
            } catch (error) {
                console.log(error);
            } finally {
                this.dLoading = false;
            }
        },
        async fuingingresosalumnoByIDAlumnoByIDEscalaByFInicio(pIdAlumno) {
            var vErrorMsg = [];
            try {
                const response = await this.$apollo.query({
                    query: gql`query ingingresosalumnoByIDAlumnoByIDEscalaByFInicio($IDAlumno: Int!, $IDEscala: Int!, $FInicio: String!){
                        ingingresosalumnoByIDAlumnoByIDEscalaByFInicio(IDAlumno: $IDAlumno, IDEscala:$IDEscala, FInicio:$FInicio){
                            Monto
                        }
                    }`,
                    variables: {
                        IDAlumno: pIdAlumno,
                        IDEscala: 626,
                        FInicio: '20240301'
                    }
                })
                let vMonto=0;
                const found10 = this.dIdAlumno10.find((element) => element ==pIdAlumno);
                const found30 = this.dIdAlumno30.find((element) => element ==pIdAlumno);

                if ((typeof found10 == "undefined") && (typeof found30 == "undefined")){
                    vErrorMsg.push('No le corresponde carnet, no tiene matricula en Periodo 2024-1<br>');
                }

                if(response.data.ingingresosalumnoByIDAlumnoByIDEscalaByFInicio.length==0){
                    vErrorMsg.push('No pagó<br>');
                } else {
                    vMonto = response.data.ingingresosalumnoByIDAlumnoByIDEscalaByFInicio[0].Monto;

                    if(vMonto==10 && typeof found10 == "undefined"){                        
                        vErrorMsg.push('Debe pagar 30 soles<br>');
                    }
                    if (vMonto<10 || (vMonto>10 && vMonto <30)) {
                        vErrorMsg.push('Debe pagar 30 soles<br>');
                    }
                }
                if(vErrorMsg.length>0){
                    Swal.fire({icon: 'error', title: '¡ ERROR !', html: vErrorMsg})
                } else {
                    this.dSnackbarMsg = 'Pagó correctamente s/.'+vMonto;
                    this.dSnackbarColor = 'primary';
                    this.dSnackbar = true;
                }
            } catch (error) {
                console.log(error);
            } finally {
            }
        },
        async fuPrialumnoByCodigo(pCodigo) {
            this.dPriAlumnoTable.loading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query prialumnoByCodigo($Codigo: String!){
                        prialumnoByCodigo(Codigo: $Codigo){
                            IdAlumno
                            Alumno
                            DNI
                            Codigo
                            Celular
                            Sexo
                            docs
                            priservicio{
                                IdServicio
                                Iniciales
                            }
                        }
                    }`,
                    variables: {
                        Codigo: pCodigo
                    }
                })
                this.dPriAlumnos = [];
                this.dPriAlumnos.push(response.data.prialumnoByCodigo);
            } catch (error) {
                console.log(error);
            } finally {
                this.dPriAlumnoTable.loading = false
            }
        },
        async fuPrialumnoByDNI(pDni) {
            this.dPriAlumnoTable.loading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query prialumnoByDNI($DNI: String!){
                        prialumnoByDNI(DNI: $DNI){
                            IdAlumno
                            Alumno
                            DNI
                            Codigo
                            Celular
                            Sexo
                            docs
                            priservicio{
                                IdServicio
                                Iniciales
                            }
                        }
                    }`,
                    variables: {
                        DNI: pDni
                    }
                })
                this.dPriAlumnos = response.data.prialumnoByDNI;
            } catch (error) {
                console.log(error);
            } finally {
                this.dPriAlumnoTable.loading = false
            }
        },
        async fuPrialumnoByAlumno(pAlumno) {
            this.dPriAlumnoTable.loading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query prialumnoByAlumno($Alumno: String!){
                        prialumnoByAlumno(Alumno: $Alumno){
                            IdAlumno
                            Alumno
                            DNI
                            Codigo
                            Celular
                            Sexo
                            docs
                            priservicio{
                                IdServicio
                                Iniciales
                            }
                        }
                    }`,
                    variables: {
                        Alumno: pAlumno
                    }
                })
                this.dPriAlumnos = response.data.prialumnoByAlumno;
            } catch (error) {
                console.log(error);
            } finally {
                this.dPriAlumnoTable.loading = false
            }
        },
        fuAlumnoSave () {
            if(this.dPriAlumno.Celular==''){
                Swal.fire({icon: 'error', title: '¡ ERROR !', html: 'Ingrese el número de celular.'})
            } else {
                this.fuAlumnoUpdate();
            }
        },
        async fuAlumnoUpdate () {
            try {
                this.dIsUpdating = true;

                const data = {
                    FechaMod : moment().format("YYYYMMDD HH:mm:ss"),
                    Celular: this.dPriAlumno.Celular,
                }

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation prialumnoUpdate($IdAlumno: ID!, $input: prialumnoUpdateInput!){
                        prialumnoUpdate(IdAlumno: $IdAlumno, input: $input){
                            IdAlumno
                            ApPaterno
                            ApMaterno
                            Nombres
                            Codigo
                            IdServicio
                            priservicio{
                                Descripcion
                            }
                        }
                    }`,
                    variables: {
                        IdAlumno: this.dPriAlumno.IdAlumno,
                        input: data
                    }
                });
                if(response.data){
                    Swal.fire({icon: 'success', title: 'Correcto', html: 'Se modificó correctamente.<br>'})
                } else {
                    Swal.fire({icon: 'error', title: '¡ ERROR !', html: 'No se guardó.<br>' + 'Intente de nuevo o comuníquese con el AREA DE TI.'})
                }
            } catch (error) {
                console.log(error);
                Swal.fire({icon: 'error',title: '¡ ERROR !',html: 'No se guardó.<br>' + 'Intente de nuevo o comuníquese con el AREA DE TI.'})
            } finally {
                this.dIsUpdating = false;
            }
        },
        toggleCamera() {
            if(this.isCameraOpen) {
                this.isCameraOpen = false;
                this.isPhotoTaken = false;
                this.isShotPhoto = false;
                this.stopCameraStream();
            } else {
                this.isCameraOpen = true;
                this.createCameraElement();
                this.dImagen = '';
            }
        },
            
        createCameraElement() {
            this.isLoading = true;
            
            const constraints = (window.constraints = {
                        audio: false,
                        video: {
                            width: { min: 1280 },
                            height: { min: 720 }
                        }
                    });


                    navigator.mediaDevices
                        .getUserMedia(constraints)
                        .then(stream => {
                            this.isLoading = false;
                            this.$refs.camera.srcObject = stream;
                        })
                        .catch(error => {
                            this.isLoading = false;
                            alert("May the browser didn't support or there is some errors.");
                            console.error("Error accediendo a la cámara:", error)
                        });
        },
            
        stopCameraStream() {
            let tracks = this.$refs.camera.srcObject.getTracks();

                    tracks.forEach(track => {
                        track.stop();
                    });
        },
            
        takePhoto() {
            if(!this.isPhotoTaken) {
                this.isShotPhoto = true;

                const FLASH_TIMEOUT = 50;

                setTimeout(() => {
                this.isShotPhoto = false;
                }, FLASH_TIMEOUT);
            }
            
            this.isPhotoTaken = !this.isPhotoTaken;
            
            const context = this.$refs.canvas.getContext('2d');
            context.drawImage(this.$refs.camera, 0, 0, 1280, 720);
        },
        uploadImage() {
            const canvas = document.getElementById("photoTaken");
            let file = null;
            this.isLoading2 = true;

            canvas.toBlob(async (blob) => {
                try {
                    var name = this.dPriAlumno.DNI + '.jpg';
                    file = new File([blob], name, { type: 'image/jpg' });

                    console.log("fileeeee", file);
                    

                    const response = await this.$apollo.mutate({
                        mutation: gql`mutation Upload($idAlumno: Int!, $idCentroProd: Int!, $tipo: String!, $file : Upload!){
                            alumnoUploadDocs(idAlumno: $idAlumno, idCentroProd: $idCentroProd, tipo: $tipo, file: $file) {
                                codError, mensaje, data
                            }
                        }`,
                        client: 'aspcore',
                        variables: { 
                            idAlumno: parseInt(this.dPriAlumno.IdAlumno),
                            idCentroProd: 1, 
                            tipo: 'FOTO', 
                            file: file 
                        },
                        context: {
                            headers: {
                                "GraphQL-preflight": 1
                            }
                        }
                    })
                    console.log(response.data);
                    
                    const DATA = response.data.alumnoUploadDocs.data.find((element) => element.key == 'FOTO').value;

                    await this.$apollo.mutate({
                        mutation: gql`mutation prialumnofotoCreate($IdAlumno: Int!, $doc: String, $id_operador: String){
                            prialumnofotoCreate(input: {
                                IdAlumno:$IdAlumno,
                                doc:$doc,
                                id_operador:$id_operador
                            }){
                                error
                                data
                            }
                        }`,
                        variables : {
                            IdAlumno: parseInt(this.dPriAlumno.IdAlumno),
                            doc: DATA,
                            id_operador: this.ssUser.IdPersonal 
                        }
                    })
                    
                    if(response.data){
                        this.dSnackbarMsg = 'Se guardo la imagen.';
                        this.dSnackbarColor = 'success';
                        this.dSnackbar = true;
                        this.dImagen = DATA;
                        this.dPriAlumno.docs = DATA;
                    } else {
                        Swal.fire({icon: 'error', title: '¡ ERROR !', html: 'No se guardó.'})
                    }
                } catch (error) {
                    console.log(error);
                    Swal.fire({icon: 'error', title: '¡ ERROR !', html: 'No se guardó..'})
                    this.stopCameraStream();
                } finally {
                    this.isLoading2 = false;
                    this.toggleCamera();
                    this.stopCameraStream();
                }
            }, 'image/jpeg');
        }
    }
}
</script>
<style scoped>
body {
  display: flex;
  justify-content: center;
}

.web-camera-container {
  margin-top: 0px;
  margin-bottom: 2px;
  padding: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;  

  @keyframes preload {
    0% {
      opacity: 1
    }
    50% {
      opacity: .4
    }
    100% {
      opacity: 1
    }
  }
}
</style>
